const AuthAPI = {


  login(data) {
    return $cfg.API.post('/auth/login/admin', data);
  },

  getData(token) {
    return $cfg.API.get('/auth/data', token ? {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    } : undefined);
  },
}

export { AuthAPI }
